import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOtherChargeCodes extends Layout {
    checkboxCoPayeeAcct: Checkbox;
    checkboxExcludeCommissions: Checkbox;
    checkboxInclInFreight: Checkbox;
    checkboxIsBackhaulTax: Checkbox;
    checkboxIsFuelSurcharge: Checkbox;
    checkboxIsIntermodal: Checkbox;
    checkboxIsTaxable: Checkbox;
    checkboxIsTonu: Checkbox;
    checkboxOoPayeeAcct: Checkbox;
    checkboxPayCompanyHourlyDriver: Checkbox;
    checkboxPrevFlag: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelC: Label;
    labelCoGlAccountDescr: Label;
    labelCoGlAccountId: Label;
    labelCompany: Label;
    labelContract: Label;
    labelGLAccount: Label;
    labelOoGlAccountDescr: Label;
    labelOoGlAccountId: Label;
    panelBillOptsCheckbox: Panel;
    panelBillOptsTextboxes: Panel;
    panelBillingOpts: Panel;
    panelCompanyDriver: Panel;
    panelContractDriver: Panel;
    panelDriverPay: Panel;
    panelDrivertoPay: Panel;
    panelGLAccounts: Panel;
    panelGeneral: Panel;
    panelGeneralCheckbox: Panel;
    panelGeneralTextbox: Panel;
    panelLogixTextbox: Panel;
    sourceChargeCode: DataSource;
    tabBilling: Tab;
    tabDriverPay: Tab;
    tabGeneral: Tab;
    tabLogixSolution: Tab;
    tabsetOtherChargeCodes: Tabset;
    textboxAmount: Textbox;
    textboxChargeRateMethod: Textbox;
    textboxCoAmount: Textbox;
    textboxCoDeductCodeId: Textbox;
    textboxCoPayMethod: Textbox;
    textboxCoPercent: Textbox;
    textboxDescr: Textbox;
    textboxEdiCode: Textbox;
    textboxGlid: Textbox;
    textboxId: Textbox;
    textboxLtlAllocationMethod: Textbox;
    textboxOoAmount: Textbox;
    textboxOoDeductCodeId: Textbox;
    textboxOoPayMethod: Textbox;
    textboxOoPercent: Textbox;
    textboxRate: Textbox;
    textboxWfMinCharge: Textbox;
    textboxWfOccDoctype: Textbox;
    textboxWfOccQueue: Textbox;
    textboxWhoToPay: Textbox;
}
